module.exports = __webpack_public_path__ + "static/2-61a69bbfc7f512a7532db98f2195ebc6.jpeg";